export default "__VITE_ASSET__Ck1TJilY__";